import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

document.addEventListener('DOMContentLoaded', () => {
	const sliders = document.querySelectorAll('.js-hero-slider');

	if (!sliders.length) {
		return;
	}

	sliders.forEach((slider) => {
		const wrapper = slider.closest('.hero-slider');
		const config = wrapper?.dataset?.swiperConfig
			? JSON.parse(wrapper.dataset.swiperConfig)
			: {};

		const pagination = slider.querySelector('.swiper-pagination');
		const nextButton = slider.querySelector('.swiper-button-next');
		const prevButton = slider.querySelector('.swiper-button-prev');

		new Swiper(slider, {
			modules: [Navigation, Pagination, Autoplay, EffectFade],
			slidesPerView: 1,
			spaceBetween: 0,
			loop: true,
			effect: 'fade',
			speed: 1000,

			autoplay: config.autoplay
				? {
						delay: config.autoplayDelay || 600000,
						disableOnInteraction: false,
					}
				: false,
			// autoplay: false,

			pagination: pagination
				? {
						el: pagination,
						clickable: true,
					}
				: false,

			navigation:
				nextButton && prevButton
					? {
							nextEl: nextButton,
							prevEl: prevButton,
						}
					: false,
		});
	});
});